// @flow
import { faCheckCircle, faPencilAlt, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@vadiun/react-components';
import PageContainer from 'layout/components/PageContainer';
import { MUIDataTableColumnDef } from 'mui-datatables';
import { createDomicilioText } from 'shared/models/DomicilioGoogle';
import { TransferReservationRepetitiveModel } from '../models/TransferreservationRepetitiveModel';
import { UseTableQueryResult } from '@vadiun/react-datatable';
import { Table } from 'shared/components';
import { CircularProgress } from '@material-ui/core';
import RefreshList from 'shared/components/Table/Refresh';

const completeHour = (hour: number) => (hour >= 10 ? hour : `0${hour}`);

interface Props {
  tableProps: UseTableQueryResult<
    TransferReservationRepetitiveModel[],
    unknown
  >;
  onLocationsDetails: (reservation: TransferReservationRepetitiveModel) => void;
  selectToEdit: (x: TransferReservationRepetitiveModel) => void;
  onDelete: (id: number) => React.ReactNode;
  handlePageChange: (currentPage: number) => void;
  onRefreshTable: () => Promise<void>;
}

export function ReservaTrasladoRepetitiveTable({
  tableProps,
  onLocationsDetails,
  selectToEdit,
  onDelete,
  handlePageChange,
  onRefreshTable
}: Props) {
  const data = tableProps.data ?? [];

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'reservation_hours',
      label: 'Horarios',
      options: {
        customBodyRenderLite: (index) => {
          return (
            <span>
              {`${data[index].reservation_hours}:${completeHour(
                data[index].reservation_minutes
              )}`}
            </span>
          );
        }
      }
    },
    {
      name: 'from_date',
      label: 'Desde',
      options: {
        customBodyRenderLite: (index) => {
          return <span>{`${data[index].from_date.format('DD/MM/YYYY')}`}</span>;
        }
      }
    },
    {
      name: 'to_date',
      label: 'Hasta',
      options: {
        customBodyRenderLite: (index) => {
          return <span>{`${data[index].to_date.format('DD/MM/YYYY')}`}</span>;
        }
      }
    },
    {
      name: 'cliente',
      label: 'Cliente',
      options: {
        customBodyRenderLite: (index) => data[index].client.name
      }
    },
    {
      name: 'puntos',
      label: 'Domicilios',
      options: {
        customBodyRenderLite: (index) => {
          return (
            <div className="flex flex-col items-start">
              {data[index].puntos.map((location, index) => (
                <div className="mb-1 flex items-start">
                  <div className="flex h-4 w-4 items-center justify-center rounded-full bg-primary-500 p-1 text-white">
                    {index + 1}
                  </div>
                  <span className="ml-1 text-center">
                    {createDomicilioText(location.domicilio)}
                  </span>
                </div>
              ))}
              <Button
                shape="circle"
                className="w-full p-2"
                onClick={() => onLocationsDetails(data[index])}
                color="blue"
              >
                <div className="flex items-center gap-1">Info</div>
              </Button>
            </div>
          );
        }
      }
    },

    {
      name: 'id',
      label: 'ID'
    },
    {
      name: 'pay_with_cash',
      label: 'Pago en efectivo',
      options: {
        setCellHeaderProps: () => ({ style: { textAlign: 'center' } }),
        customBodyRenderLite: (index) => data[index].pay_with_cash ? (
          <div className="flex justify-center items-center">
            <div
              style={{
                color: '#008282',
                borderRadius: '50%',
                boxShadow: '0px 0px 8px #008282',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FontAwesomeIcon icon={faCheckCircle} />
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center">
            <div
              style={{
                color: '#8A8A8A',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>
          </div>
        )
      }
    },
    {
      label: 'Acciones',
      name: 'id',
      options: {
        customBodyRenderLite: (index) => (
          <div className="flex space-x-2">
            <Button
              onClick={() => selectToEdit(data[index])}
              shape="circle"
              color="primary"
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </Button>
            {onDelete(data[index].id)}
          </div>
        )
      }
    }
  ];

  return (
    <PageContainer lessMargin>
      <div className="w-full">
        <Table
          title={
            tableProps.isFetching && (
              <div className="flex items-center gap-4">
                <CircularProgress size={30} />
                <p className="text-gray-500">Cargando...</p>
              </div>
            )
          }
          components={{
            TableToolbar: () => (
              <div className="flex justify-end py-1 px-4">
                <RefreshList onRefreshTable={onRefreshTable} />
              </div>
            )
          }}
          options={{
            elevation: 0,
            search: false,
            filter: false,
            sort: false,
            download: false,
            print: false,
            ...tableProps.serverSideOptions,
            rowsPerPageOptions: [10, 30, 50, 100, 200, 300, 400, 500],
            onChangePage: handlePageChange
          }}
          data={data}
          columns={columns}
        />
        {/* <Table
          data={data}
          options={{
            elevation: 0,
            selectableRows: 'none',
            search: false,
            filter: false,
            sort: false,
            print: false,
            download: false,
            rowsPerPageOptions: [10, 30, 50, 100, 200, 300, 400, 500],
            onChangePage: handlePageChange,
            ...tableProps.serverSideOptions
          }}
          title={''}
          columns={columns}
        /> */}
      </div>
    </PageContainer>
  );
}
